const API_URL = 'https://api.svet-ai.work';
const WEBSITE_URL = 'https://svet-ai.work';

export const environment = {
  production: false,
  allowIndexing: false, // Empêche l'indexation en dev
  websiteUrl: WEBSITE_URL,
  apiUrl: API_URL,
  socketIoUrl: API_URL + '/ws',
  stripe_public_key:
    'pk_test_51RFFUVR1X5dLdyWjJtJKjX48UI6NdGyjWbEr71L3kKbF56YaUUOrlZSwYWY3QY3wgHjUZ3PIL8PSSypAzXsm0yoI00S3g4LDPt',
  socials: {
    discord_url: 'https://discord.gg/BdzpJjfsEh',
    instagram_url: 'https://www.instagram.com/svetaiofficiel/',
    linkedin_url: 'https://www.linkedin.com/company/108328997/',
  },
};
